import React, {Component} from 'react';
import {Form, Input, Row, Modal, Upload, Icon, Col, Button} from 'antd';
import {API_TOKEN, uploadLogo} from '../../modules/Api';
import equal from 'fast-deep-equal'
import {END_STATIC_POINT,END_POINT} from '../../constants/config';
const FormItem = Form.Item;

class SubcategoryModal extends Component {

    static initialState() {
        return {
            title: '',
            image: '',
            images: [],
            meta_title: null,
            meta_description: null,
            description: null
        };
    }

    handleCancel = () => this.setState({ previewVisible: false })

    handlePreview = (file) => {
        this.setState({
            previewImage: file.url || file.thumbUrl,
            previewVisible: true,
        });
    }

    handleChange = ({ fileList }) => {
        this.setState({ fileList : fileList });
    }

    constructor(props) {
        super(props);
        this.state = {
            data: props.state,
            previewVisible: false,
            previewImage: '',
            fileList: props.initialData.images,
            image: props.initialData.image,
            ACTION: END_POINT+'/api/management/upload/to-webp?api_token='+API_TOKEN+'&path=categories&slider_type=category',//uploaderAction('categories')
        };
    }

    componentWillReceiveProps(prevProps) {
        if(!equal(this.state.fileList, prevProps.initialData.images) && !equal(this.props.initialData.images, prevProps.initialData.images)) {
            this.setState({
                fileList: prevProps.initialData.images
            });
        }
    }

    commit(e) {
        e.preventDefault();
        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }

            this.props.commit(Object.assign({}, fieldsValue, {
                id: this.props.initialData.id,
                images: this.state.fileList.map(v => v.response ? v.response : v.url),
                image: this.state.image,
            }));

            this.setState({fileList: []})
            this.props.form.resetFields();
        })

    }

    cancel() {
        this.setState({fileList: []})
        this.props.close();
        this.props.form.resetFields();
    }

    render() {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
                wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        };
        const {getFieldDecorator} = this.props.form;
        const { previewVisible, previewImage, fileList, ACTION } = this.state;
        const uploadButton = (
            <div>
              <Icon type="plus" />
              <div className="ant-upload-text">Upload</div>
            </div>
          );
        return (
            <div style={{direction: 'rtl'}}>
                <Modal
                    width="70%"
                    title="ایجاد زیر دسته"
                    visible={this.props.visible}
                    onOk={this.commit.bind(this)}
                    onCancel={this.cancel.bind(this)}>
                        <Form style={{direction:'rtl'}}>
                            <Row>
                            <Col span={22} offset={1}>
                                <FormItem
                                    {...formItemLayout}
                                    label="عنوان"
                                    colon={false}>
                                    {getFieldDecorator('title', {
                                        initialValue: this.props.initialData.title,
                                        rules: [{
                                            required: true, message: 'عنوان را وارد نمایید',
                                        }],
                                    })(
                                        <Input style={{direction:'rtl'}} />
                                    )}
                                </FormItem>

                                <FormItem
                                    {...formItemLayout}
                                    label="عنوان متا"
                                    colon={false}>
                                    {getFieldDecorator('meta_title', {
                                        initialValue: this.props.initialData.meta_title,
                                        rules: [{
                                            required: true, message: 'عنوان متا را وارد نمایید',
                                        }],
                                    })(
                                        <Input style={{direction:'rtl'}} />
                                    )}
                                </FormItem>

                                <FormItem
                                    {...formItemLayout}
                                    label="توضیحات متا"
                                    colon={false}>
                                    {getFieldDecorator('meta_description', {
                                        initialValue: this.props.initialData.meta_description,
                                        rules: [{
                                            required: true, message: 'توضیحات متا را وارد نمایید',
                                        }],
                                    })(
                                        <Input.TextArea style={{direction:'rtl'}} />
                                    )}
                                </FormItem>

                                <FormItem
                                    {...formItemLayout}
                                    label="عکس‌ها"
                                    colon={false}>
                                    {getFieldDecorator('images', {
                                        initialValue: this.props.initialData.images,
                                        rules: []
                                    })(
                                        <div className="clearfix">
                                            <Upload
                                            action={ACTION}
                                            listType="picture-card"
                                            fileList={fileList}
                                            onPreview={this.handlePreview}
                                            onChange={this.handleChange}
                                            multiple={true}
                                            >
                                            {fileList && fileList.length >= 100 ? null : uploadButton}
                                            </Upload>
                                            <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                                                <img alt="example" style={{ width: '100%' }} src={previewImage} />
                                            </Modal>
                                        </div>
                                    )}
                                </FormItem>

                                <FormItem
                                    {...formItemLayout}
                                    label="توضیحات(درباره زیردسته)"
                                    colon={false}>
                                    {getFieldDecorator('description', {
                                        initialValue: this.props.initialData.description,
                                        rules: [],
                                    })(
                                        <Input.TextArea style={{direction:'rtl'}} rows="5" />
                                    )}
                                </FormItem>

                                <FormItem
                                    {...formItemLayout}
                                    label="لوگو زیردسته"
                                    extra="بهتر است فایل انتخابی مربعی و حداقل عرض 100 پیکسل و فرمت jpg باشد."
                                    colon={false}>
                                    {getFieldDecorator('upload', {
                                        valuePropName: 'fileList',
                                        getValueFromEvent: this.normFile,
                                    })(
                                        <Upload
                                        name="logo"
                                        action=""
                                        customRequest={() => {}}
                                        onChange={f => {uploadLogo(f, (src) => {this.setState({image: src})})}}
                                        listType="picture"
                                        showUploadList={false}>
                                        <Button>
                                            <Icon type="upload" /> انتخاب فایل
                                        </Button>
                                        <br />
                                        {this.props.initialData.image && <img src={`${this.props.initialData.image.includes('http') ? this.props.initialData.image : END_STATIC_POINT + this.props.initialData.image}`} style={{width: '50px', height: '50px', margin: '10px'}} alt="لوگو زیردسته"/>}
                                        </Upload>
                                    )}
                                </FormItem>
                            </Col>
                            </Row>
                        </Form>
                </Modal>
            </div>
        )
    }
}


SubcategoryModal.defaultProps = {
    initialData: {},
    visible: false,
    open: () => {},
    close: () => {},
    commit: () => {},
}

export default Form.create()(SubcategoryModal);



// WEBPACK FOOTER //
// ./src/components/Category/index.js